export class ProblemDetails {
  title: string;
  status: number;
  detail: string;
  instance: string;
}

export class ValidationProblemDetails extends ProblemDetails {
  errors: any[];
}

export class NotFoundError {
}
